// extracted by mini-css-extract-plugin
export default {"container":"QuickMenus_container__OpjBv","shop":"QuickMenus_shop__yrj72","icon":"QuickMenus_icon__EKfnb","top":"QuickMenus_top__+G2ce","title":"QuickMenus_title__80owN"};